/**
 * 對話頁共用行內樣式常數（UI v2 步 5：由 `ChatPage.tsx` **純搬**出嚟，零行為改動）
 *
 * ⚠️ 呢啲係**過渡**樣式（設計 v2 會逐步換成 `app.css` class）；現階段照搬，唔改值。
 */
import type { CSSProperties } from 'react';

export const TEXT_BTN: CSSProperties = {
  minHeight: '36px',
  padding: '0 12px',
  borderRadius: '18px',
  border: '1.5px solid var(--color-divider)',
  background: 'var(--color-card)',
  color: 'var(--color-text)',
  fontFamily: 'inherit',
  fontSize: 'var(--font-size-small, 15px)',
  fontWeight: 700,
  cursor: 'pointer',
};

export const PRIMARY_BTN: CSSProperties = {
  border: '1.5px solid var(--color-primary)',
  background: 'var(--color-primary)',
  color: 'var(--color-on-primary)',
};

export const ICON_BTN: CSSProperties = {
  ...TEXT_BTN,
  minWidth: '44px',
  minHeight: '44px',
  padding: 0,
  fontSize: 'var(--font-size-button, 18px)',
};

export const ROW_BTN: CSSProperties = {
  ...TEXT_BTN,
  minHeight: '40px',
  padding: '0 14px',
  borderRadius: '999px',
  border: '1.5px solid var(--color-primary)',
  color: 'var(--color-primary-strong, var(--color-primary))',
};

export const PLAY_BTN: CSSProperties = {
  ...ROW_BTN,
  minHeight: '36px',
  background: 'var(--color-primary)',
  color: 'var(--color-on-primary)',
  border: 'none',
};

export const SHEET_PRIMARY: CSSProperties = {
  ...TEXT_BTN,
  ...PRIMARY_BTN,
  width: '100%',
  minHeight: '48px',
  fontSize: 'var(--font-size-button, 18px)',
};
